export default __webpack_public_path__ + "static/media/ic_user_register.dabb833c.svg";